import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Leaf, ShoppingBag, Moon, BarChart3, DollarSign, BookOpen, ClipboardCheck } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function PricingCTA() {
  const stackItems = [{
    icon: <BookOpen className="w-5 h-5" data-id="element-147" />,
    title: 'Plantas Mexicanas para Dormir Profundo — Protocolo completo',
    type: 'Producto Principal',
    value: '$17 USD',
    isFree: false
  }, {
    icon: <ClipboardCheck className="w-5 h-5" data-id="element-148" />,
    title: 'La Lista CERO-ERROR del Mercado + Identificador Visual',
    type: 'Bono #1',
    value: '$22 USD',
    isFree: true
  }, {
    icon: <Moon className="w-5 h-5" data-id="element-149" />,
    title: 'Ritual 10 Min: Guión Nocturno Anti-Desvelo',
    type: 'Bono #2',
    value: '$22 USD',
    isFree: true
  }, {
    icon: <BarChart3 className="w-5 h-5" data-id="element-150" />,
    title: 'Tracker Sueño 7 Noches + Calculadora de Progreso',
    type: 'Bono #3',
    value: '$22 USD',
    isFree: true
  }];
  const recapItems = [{
    icon: <Leaf className="w-5 h-5" data-id="element-151" />,
    text: 'El protocolo de 4 plantas que rota sin crear tolerancia.'
  }, {
    icon: <ShoppingBag className="w-5 h-5" data-id="element-152" />,
    text: 'La lista CERO-ERROR para comprar sin equivocarte.'
  }, {
    icon: <Moon className="w-5 h-5" data-id="element-153" />,
    text: 'El ritual de 10 minutos para apagar el día sin fuerza de voluntad.'
  }, {
    icon: <BarChart3 className="w-5 h-5" data-id="element-154" />,
    text: 'El tracker de 7 noches para medir tu progreso con datos reales.'
  }, {
    icon: <DollarSign className="w-5 h-5" data-id="element-155" />,
    text: 'Todo por $17 (valor real $83).'
  }, {
    icon: <Shield className="w-5 h-5" data-id="element-156" />,
    text: 'Garantía 7 días sin preguntas.'
  }];
  return <section id="pricing" className="py-14 md:py-24 px-4 bg-forest-900 relative overflow-hidden" data-id="element-157">
      {/* Glow effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-green-500 rounded-full blur-[150px] opacity-10 pointer-events-none" data-id="element-158" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-159">
        {/* Main CTA Card */}
        <div className="bg-forest-800/80 backdrop-blur-md border border-forest-600 rounded-2xl md:rounded-3xl p-6 md:p-12 shadow-2xl mb-16" data-id="element-160">
          {/* Value Stack Table */}
          <div className="mb-8" data-id="element-161">
            <h2 className="text-2xl md:text-4xl font-serif font-bold text-gold-500 mb-2 text-center" data-id="element-162">
              Mirá lo que te llevás hoy:
            </h2>
            <div className="bg-forest-900 rounded-xl border border-forest-600 overflow-hidden mt-6" data-id="element-163">
              <div className="divide-y divide-forest-700/50" data-id="element-164">
                {stackItems.map((item, index) => <div key={index} className="flex flex-col sm:flex-row items-start sm:items-center p-4 md:p-5 gap-3" data-id="element-165">
                    <div className="flex items-center gap-3 w-full sm:w-auto sm:min-w-[140px]" data-id="element-166">
                      <div className={`p-1.5 rounded-lg shrink-0 ${item.isFree ? 'bg-gold-500/10 text-gold-500' : 'bg-green-500/10 text-green-500'}`} data-id="element-167">
                        {item.icon}
                      </div>
                      <span className="font-bold text-cream-100 text-sm" data-id="element-168">
                        {item.type}
                      </span>
                    </div>
                    <div className="flex-1 text-cream-200 text-sm" data-id="element-169">
                      {item.title}
                    </div>
                    <div className="flex items-center gap-2 shrink-0" data-id="element-170">
                      <span className={`text-sm ${item.isFree ? 'text-cream-300 line-through' : 'text-cream-100 font-bold'}`} data-id="element-171">
                        {item.value}
                      </span>
                      {item.isFree && <span className="bg-green-500 text-forest-900 text-xs font-bold px-2 py-0.5 rounded uppercase" data-id="element-172">
                          GRATIS
                        </span>}
                    </div>
                  </div>)}
              </div>
              {/* Price + CTA together */}
              <div className="bg-forest-700/30 p-5 md:p-8 border-t-2 border-forest-600" data-id="element-173">
                <div className="flex justify-between items-center mb-3" data-id="element-174">
                  <span className="text-cream-300" data-id="element-175">Valor total real</span>
                  <span className="text-cream-300 text-lg line-through" data-id="element-176">
                    $83 USD
                  </span>
                </div>
                <div className="flex justify-between items-center mb-6" data-id="element-177">
                  <span className="text-gold-400 font-bold text-lg md:text-xl" data-id="element-178">
                    Hoy pagás
                  </span>
                  <span className="text-gold-500 font-bold text-3xl md:text-4xl font-serif" data-id="element-179">
                    $17 USD
                  </span>
                </div>

                <motion.a href="https://www.rutinasimple.com/cart/52042797383961:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="w-full inline-flex items-center justify-center bg-green-500 hover:bg-green-400 text-white font-bold text-lg md:text-xl px-6 md:px-10 py-5 md:py-6 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.4)] hover:shadow-[0_0_40px_rgba(34,197,94,0.6)] transition-all mb-4" data-id="element-180">
                  SÍ — QUIERO EL PROTOCOLO + LOS 3 BONOS POR $17
                </motion.a>

                <p className="text-sm text-cream-200 font-medium text-center mb-4" data-id="element-181">
                  Acceso inmediato. PDF + Audio. Los 3 bonos incluidos. Garantía
                  7 días — sin riesgo.
                </p>

                <div className="bg-forest-900/50 rounded-lg p-3 flex flex-col sm:flex-row items-center justify-center gap-2 text-xs md:text-sm text-cream-300/80 border border-forest-700" data-id="element-182">
                  <Lock className="w-4 h-4 text-green-500 shrink-0" data-id="element-183" />
                  <p className="text-center sm:text-left" data-id="element-184">
                    Pago seguro. Acceso en menos de 2 minutos. Tu información
                    está protegida.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Closing Copy */}
          <div className="space-y-4 text-center text-cream-200" data-id="element-185">
            <p className="text-lg" data-id="element-186">
              Todo esto — el protocolo + los 3 bonos — por{' '}
              <span className="text-gold-400 font-bold" data-id="element-187">$17</span>. No por{' '}
              <span className="line-through text-cream-400" data-id="element-188">$83</span>. No por{' '}
              <span className="line-through text-cream-400" data-id="element-189">$47</span>. No por{' '}
              <span className="line-through text-cream-400" data-id="element-190">$27</span>.{' '}
              <span className="font-bold text-cream-100" data-id="element-191">
                Por diecisiete dólares.
              </span>
            </p>
            <p className="text-sm text-cream-300 italic" data-id="element-192">
              Los bonos son parte de este lanzamiento. No van a estar aquí para
              siempre a este precio.
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-gradient-to-r from-transparent via-forest-600 to-transparent mb-16" data-id="element-193" />

        {/* Doubt Crusher Section */}
        <div className="max-w-3xl mx-auto" data-id="element-194">
          <div className="text-center mb-10" data-id="element-195">
            <h3 className="text-3xl font-serif font-bold text-gold-500 mb-6" data-id="element-196">
              ¿Todavía pensando?
            </h3>
            <div className="space-y-4 text-lg text-cream-200 text-left md:text-center" data-id="element-197">
              <p data-id="element-198">
                Entiendo. Ya probaste cosas antes. Ya gastaste en pastillas que
                no funcionaron.
              </p>
              <p data-id="element-199">Esto es diferente por una razón:</p>
              <p className="font-bold text-cream-100 text-xl" data-id="element-200">
                No es un sedante. Es un entrenador.
              </p>
              <p data-id="element-201">
                Tu cerebro aprende. Se adapta. Y cuando rota las plantas, nunca
                crea tolerancia.
              </p>
              <p className="italic text-cream-300" data-id="element-202">
                Juan lo hizo. Pasó de 4 horas a 7.5 en una semana.
              </p>
              <p className="text-gold-400 font-medium pt-2" data-id="element-203">
                $17 es menos que una caja de pastillas que ya sabés que no
                funcionan.
              </p>
            </div>
          </div>

          {/* Bullet Recap */}
          <div className="bg-forest-800 rounded-2xl p-6 md:p-10 border border-forest-600 mb-10" data-id="element-204">
            <h4 className="text-xl font-bold text-cream-100 mb-6 text-center" data-id="element-205">
              Recordatorio de lo que te llevás:
            </h4>
            <ul className="space-y-4" data-id="element-206">
              {recapItems.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-207">
                  <div className="bg-forest-700 p-2 rounded-lg text-gold-500 shrink-0" data-id="element-208">
                    {item.icon}
                  </div>
                  <span className="text-cream-200 mt-1" data-id="element-209">{item.text}</span>
                </li>)}
            </ul>
          </div>

          {/* Final CTA */}
          <div className="text-center" data-id="element-210">
            <motion.a href="#pricing" onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full md:w-auto inline-flex items-center justify-center bg-green-500 hover:bg-green-400 text-white font-bold text-lg md:text-xl px-8 md:px-12 py-5 md:py-6 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.4)] hover:shadow-[0_0_40px_rgba(34,197,94,0.6)] transition-all cursor-pointer" data-id="element-211">
              EMPEZAR ESTA NOCHE — $17 USD
            </motion.a>
          </div>
        </div>
      </div>
    </section>;
}